import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '../Typography.component';
import { CloseButton, WrappedButton } from '../button';
import { Link } from '../Link.component';
import variants from '../meta/variants';

// https://www.figma.com/design/A1suqNxo7ab0Zq7gxCiwaE?node-id=7346-6882&main-component=1&fuid=1313596124397256800

export const InlineMessage = ({
	header,
	text,
	type,
	actions,
	canClose = false,
	onClose = null,
	hidden = false,
	dataqa = '',
}) => {
	const [isHiddenInternal, setHiddenInternal] = useState(false);

	if (hidden || isHiddenInternal) {
		return null;
	}

	// function to handle close button click
	const handleClose = () => {
		setHiddenInternal(true);

		if (onClose) {
			onClose();
		}
	};

	return (
		<div className={`common-ui-inline-message ${type}`}>
			<i className={`${type} icon`} aria-hidden="true" />
			<div className="content">
				{header && (
					<Typography.HeadingLabel className="bold">{header}</Typography.HeadingLabel>
				)}
				{text && <Typography.P>{text}</Typography.P>}
				{actions && <div className="actions">{actions}</div>}
			</div>
			{canClose && (
				<CloseButton onClick={handleClose} dataqa={`${dataqa}-inline-message-close`} />
			)}
		</div>
	);
};

InlineMessage.propTypes = {
	// Text can be either a plain string or text with Link component
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	type: PropTypes.oneOf(variants),
	// Actions can be either a single button/link or an array of buttons/links
	// Each action must be either a WrappedButton or Link component
	actions: PropTypes.oneOfType([
		PropTypes.shape({ type: PropTypes.oneOf([WrappedButton, Link]) }),
		PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.oneOf([WrappedButton, Link]) })),
	]),
	canClose: PropTypes.bool,
	onClose: PropTypes.func,
	hidden: PropTypes.bool,
	dataqa: PropTypes.string.isRequired,
};

export default InlineMessage;
